<template>
  <button @click="onClick">
    <span v-if="!loading">Sign up</span>
    <Loader v-if="loading" :auto="true" color="white"/>
  </button>
</template>

<script>
import Loader from '@/components/Loader'

export default {
  name: 'SignupButton',
  data() {
    return {
      iframe: false,
      loading: false
    }
  },
  components: {
    Loader
  },
  methods: {
    onClick() {
      this.$emit('click');
    }
  },
  mounted() {
    if(window.location !== window.parent.location) {
      this.iframe = true;
    }
  }
}
</script>

<style lang="scss" scoped>
button {
  width: 6rem;
  height: 2.5rem;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 0.3s;
  background: none;
  outline: none;
  border: none;
  color: white;
  font-weight: bold;
  font-size: 1.2rem;
  background-color: #e6c17d;
  border-radius: 0.2rem;

  &:hover {
    cursor: pointer;
    opacity: 0.8;
  }
}
</style>